module.exports = __webpack_public_path__ + "media/images/preview-99c9f0594143dc732a5d596ab334f95b.png";